(function () {
  const shopBtn = document.querySelector("[data-ph-shop]");
  const panel = document.querySelector("[data-ph-shop-panel]");
  const menuBtn = document.querySelector("[data-ph-menu]");
  const drawer = document.querySelector("[data-ph-drawer]");
  const header = document.querySelector(".ph-header-bar");
  const dest = document.querySelector("[data-ph-dest]");
  const destToggle = document.querySelector("[data-ph-dest-toggle]");
  const destMenu = document.querySelector("[data-ph-dest-menu]");
  const searchRoot = document.querySelector("[data-ph-search]");
  const searchToggle = document.querySelector("[data-ph-search-toggle]");
  const searchForm = document.querySelector("[data-ph-search-form]");
  const searchInput = document.querySelector("[data-ph-search-input]");
  const searchClose = document.querySelector("[data-ph-search-close]");

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    document.documentElement.classList.toggle("ph-menu-open", open);
    if (menuBtn) {
      menuBtn.textContent = open ? "Close" : "Menu";
      menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    }
    if (open && header) {
      drawer.style.top = Math.ceil(header.getBoundingClientRect().bottom) + "px";
    }
  }

  function setDestOpen(open, pinned) {
    if (!dest) return;
    dest.classList.toggle("is-open", open);
    if (destToggle) destToggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (open && pinned) {
      dest.dataset.phDestPinned = "1";
    } else if (!open) {
      delete dest.dataset.phDestPinned;
    }
  }

  function setShopOpen(open) {
    panel?.classList.toggle("is-open", open);
    if (shopBtn) shopBtn.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function shopHoverEnabled() {
    return window.matchMedia("(hover: hover) and (min-width: 901px)").matches;
  }

  let shopHoverTimer;
  function scheduleShopClose() {
    window.clearTimeout(shopHoverTimer);
    shopHoverTimer = window.setTimeout(function () {
      if (shopBtn?.matches(":hover") || panel?.matches(":hover")) return;
      setShopOpen(false);
    }, 180);
  }

  function openShopFromHover() {
    if (!shopHoverEnabled()) return;
    window.clearTimeout(shopHoverTimer);
    setShopOpen(true);
    setDestOpen(false);
    setSearchOpen(false);
  }

  function setSearchOpen(open) {
    if (!searchRoot || !searchToggle || !searchForm) return;
    searchRoot.classList.toggle("is-open", open);
    searchToggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      searchForm.removeAttribute("hidden");
      window.requestAnimationFrame(function () {
        searchInput?.focus();
        searchInput?.select?.();
      });
    } else {
      searchForm.setAttribute("hidden", "");
      if (searchInput) searchInput.blur();
    }
  }

  shopBtn?.addEventListener("click", function () {
    const opening = !panel?.classList.contains("is-open");
    setShopOpen(opening);
    if (opening) {
      setDestOpen(false);
      setSearchOpen(false);
    }
  });

  shopBtn?.addEventListener("mouseenter", openShopFromHover);
  shopBtn?.addEventListener("mouseleave", function () {
    if (!shopHoverEnabled()) return;
    scheduleShopClose();
  });
  panel?.addEventListener("mouseenter", function () {
    if (!shopHoverEnabled()) return;
    window.clearTimeout(shopHoverTimer);
  });
  panel?.addEventListener("mouseleave", function () {
    if (!shopHoverEnabled()) return;
    scheduleShopClose();
  });

  searchToggle?.addEventListener("click", function (event) {
    event.preventDefault();
    const opening = !searchRoot?.classList.contains("is-open");
    setSearchOpen(opening);
    if (opening) {
      setShopOpen(false);
      setDestOpen(false);
    }
  });

  searchClose?.addEventListener("click", function (event) {
    event.preventDefault();
    setSearchOpen(false);
    searchToggle?.focus();
  });

  searchInput?.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      event.preventDefault();
      setSearchOpen(false);
      searchToggle?.focus();
    }
  });

  // Click navigates to the all-resorts page (href on the toggle).
  // Hover still opens the specific-resort strip.

  dest?.addEventListener("mouseenter", function () {
    setDestOpen(true, dest?.dataset.phDestPinned === "1");
    setShopOpen(false);
  });

  dest?.addEventListener("mouseleave", function () {
    if (dest?.dataset.phDestPinned === "1") return;
    window.setTimeout(function () {
      if (!dest?.matches(":hover")) setDestOpen(false);
    }, 120);
  });

  document.addEventListener("click", function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (dest && !dest.contains(target)) setDestOpen(false);
    if (panel && shopBtn && !panel.contains(target) && !shopBtn.contains(target)) {
      setShopOpen(false);
    }
    if (searchRoot && !searchRoot.contains(target)) {
      setSearchOpen(false);
    }
  });

  // Keep pinned open while choosing a resort inside the strip
  destMenu?.addEventListener("click", function (event) {
    const link = event.target.closest("a");
    if (link) {
      // Allow navigation; menu can close naturally on page change
      dest.dataset.phDestPinned = "1";
      setDestOpen(true, true);
    }
  });

  menuBtn?.addEventListener("click", function () {
    setDrawer(!drawer?.classList.contains("is-open"));
  });

  // Mobile drawer accordion: tap a section to show / hide its options
  if (drawer) {
    drawer.querySelectorAll("[data-ph-acc-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const item = btn.closest("[data-ph-acc]");
        if (!item) return;
        const opening = !item.classList.contains("is-open");
        drawer.querySelectorAll("[data-ph-acc]").forEach(function (other) {
          const otherBtn = other.querySelector("[data-ph-acc-btn]");
          const otherPanel = other.querySelector("[data-ph-acc-panel]");
          const isThis = other === item && opening;
          other.classList.toggle("is-open", isThis);
          if (otherBtn) otherBtn.setAttribute("aria-expanded", isThis ? "true" : "false");
          if (otherPanel) {
            if (isThis) otherPanel.removeAttribute("hidden");
            else otherPanel.setAttribute("hidden", "");
          }
        });
      });
    });
  }

  // On mobile, Shop in the top bar opens the Menu drawer (accordion) instead of the desktop mega panel
  shopBtn?.addEventListener("click", function (event) {
    if (!window.matchMedia("(max-width: 900px)").matches) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    setShopOpen(false);
    setDrawer(true);
    const shopAcc = drawer?.querySelector("[data-ph-acc]");
    if (shopAcc) {
      drawer.querySelectorAll("[data-ph-acc]").forEach(function (other) {
        const otherBtn = other.querySelector("[data-ph-acc-btn]");
        const otherPanel = other.querySelector("[data-ph-acc-panel]");
        const isThis = other === shopAcc;
        other.classList.toggle("is-open", isThis);
        if (otherBtn) otherBtn.setAttribute("aria-expanded", isThis ? "true" : "false");
        if (otherPanel) {
          if (isThis) otherPanel.removeAttribute("hidden");
          else otherPanel.setAttribute("hidden", "");
        }
      });
    }
  }, true);

  if (new URLSearchParams(location.search).has("shop")) {
    setShopOpen(true);
    if (window.matchMedia("(max-width: 900px)").matches) setDrawer(true);
  }
})();

/* Resort editorial carousels (Stay / Eat / Play) */
(function () {
  function syncCarousel(carousel) {
    var track = carousel.querySelector("[data-ph-ed-track]");
    var prev = carousel.querySelector("[data-ph-ed-prev]");
    var next = carousel.querySelector("[data-ph-ed-next]");
    if (!track || !prev || !next) return;
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var canScroll = max > 2;
    prev.disabled = !canScroll || track.scrollLeft <= 2;
    next.disabled = !canScroll || track.scrollLeft >= max - 2;
    carousel.classList.toggle("is-scrollable", canScroll);
  }

  function bindAll() {
    document.querySelectorAll("[data-ph-ed-carousel]").forEach(function (carousel) {
      if (carousel.getAttribute("data-ph-bound") === "1") return;
      carousel.setAttribute("data-ph-bound", "1");
      var track = carousel.querySelector("[data-ph-ed-track]");
      if (!track) return;
      track.addEventListener(
        "scroll",
        function () {
          syncCarousel(carousel);
        },
        { passive: true }
      );
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          syncCarousel(carousel);
        }).observe(track);
      }
      syncCarousel(carousel);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindAll);
  } else {
    bindAll();
  }
  document.addEventListener("shopify:section:load", bindAll);
})();

/* Accordion multi-select for ski resort + alphabet mugs */
(function () {
  function selectedInputs(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(".ph-opt-accordion__input:checked:not(:disabled)")
    );
  }

  function updateSummary(accordion) {
    var summary = accordion.querySelector("[data-ph-accordion-summary]");
    if (!summary) return;
    var values = selectedInputs(accordion).map(function (input) {
      return input.value;
    });
    if (!values.length) {
      summary.textContent = "Choose one or more";
      return;
    }
    if (values.length <= 3) {
      summary.textContent = values.join(", ");
      return;
    }
    summary.textContent = values.length + " selected";
  }

  function syncVariantSelect(formRoot, accordion) {
    var select = formRoot.querySelector("select.original-selector");
    if (!select) return;
    var first = selectedInputs(accordion)[0];
    select.value = first ? first.getAttribute("data-variant-id") || "" : "";
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function bindAccordion(accordion) {
    if (accordion.getAttribute("data-ph-bound") === "1") return;
    accordion.setAttribute("data-ph-bound", "1");

    var toggle = accordion.querySelector(".ph-opt-accordion__toggle");
    var panel = accordion.querySelector(".ph-opt-accordion__panel");
    var formRoot = accordion.closest(".product-form") || document;

    // Do not keep the theme's default first-variant selection — user must pick.
    var select = formRoot.querySelector("select.original-selector");
    if (select) {
      select.value = "";
    }

    if (toggle && panel) {
      toggle.addEventListener("click", function () {
        var open = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", open ? "false" : "true");
        if (open) {
          panel.setAttribute("hidden", "");
        } else {
          panel.removeAttribute("hidden");
        }
      });
    }

    accordion.querySelectorAll(".ph-opt-accordion__input").forEach(function (input) {
      input.addEventListener("change", function () {
        var item = input.closest(".ph-opt-accordion__item");
        if (item) item.classList.toggle("is-selected", input.checked);
        accordion.classList.remove("option-selector--empty");
        var prefix = accordion.querySelector(".label__prefix");
        if (prefix) prefix.remove();
        updateSummary(accordion);
        syncVariantSelect(formRoot, accordion);
      });
    });

    updateSummary(accordion);
  }

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cart_add_url) {
      return theme.routes.cart_add_url;
    }
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart/add.js";
  }

  function bindMultiAdd(formRoot) {
    if (formRoot.getAttribute("data-ph-accordion-bound") === "1") return;
    var accordion = formRoot.querySelector("[data-ph-accordion-multi='true'].option-selector--ph-accordion");
    if (!accordion) return;
    formRoot.setAttribute("data-ph-accordion-bound", "1");

    var form = formRoot.querySelector("form.product-purchase-form");
    if (!form) return;

    form.addEventListener(
      "submit",
      function (evt) {
        var inputs = selectedInputs(accordion);
        if (!inputs.length) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          accordion.classList.add("option-selector--empty");
          var label = accordion.querySelector(".ph-opt-accordion__label, .label");
          if (label && !accordion.querySelector(".label__prefix")) {
            var prefix = document.createElement("span");
            prefix.className = "label__prefix";
            prefix.textContent =
              (window.theme && theme.strings && theme.strings.products_product_pick_a
                ? theme.strings.products_product_pick_a + " "
                : "Pick a ");
            label.prepend(prefix);
          }
          if (window.theme && typeof theme.scrollToRevealElement === "function") {
            theme.scrollToRevealElement(accordion);
          } else {
            accordion.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          return;
        }

        // Multi-variant add when more than one option is selected
        if (inputs.length < 2) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();

        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : "1", 10) || 1);
        var items = inputs.map(function (input) {
          return {
            id: Number(input.getAttribute("data-variant-id")),
            quantity: qty
          };
        });

        var submitBtns = form.querySelectorAll('button[type="submit"]');
        submitBtns.forEach(function (btn) {
          btn.disabled = true;
          if (!btn.dataset.previousValue) {
            btn.dataset.previousValue = btn.textContent;
          }
          if (window.theme && theme.strings && theme.strings.products_product_adding_to_cart) {
            btn.textContent = theme.strings.products_product_adding_to_cart;
          }
        });

        if (window.theme && typeof theme.removeAddedCartDrawer === "function") {
          theme.removeAddedCartDrawer();
        }

        var useDrawer =
          window.theme &&
          theme.settings &&
          theme.settings.cart_type === "drawer" &&
          formRoot.getAttribute("data-ajax-add-to-cart") === "true";

        var payload = { items: items };
        if (useDrawer) {
          payload.sections = "cart-drawer";
          payload.sections_url = window.location.pathname;
        }

        fetch(cartAddUrl(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function (response) {
            document.documentElement.dispatchEvent(
              new CustomEvent("theme:cartchanged", { bubbles: true, cancelable: false })
            );

            submitBtns.forEach(function (btn) {
              btn.disabled = false;
              var done =
                window.theme && theme.strings && theme.strings.products_product_added_to_cart
                  ? theme.strings.products_product_added_to_cart
                  : "Added";
              btn.textContent = done;
              btn.classList.add("inverted");
              window.setTimeout(function () {
                btn.classList.remove("inverted");
                btn.textContent = btn.dataset.previousValue || "Add to cart";
              }, 3000);
            });

            if (useDrawer && response.sections && response.sections["cart-drawer"] && window.jQuery) {
              var $cartDrawerContainer = window.jQuery(response.sections["cart-drawer"]);
              var cartDrawer = $cartDrawerContainer.find(".cart-summary-overlay")[0];
              if (cartDrawer) {
                cartDrawer.classList.add("cart-summary-overlay--off-screen");
                var shopMore = cartDrawer.querySelector(".shop-more");
                if (shopMore) {
                  shopMore.addEventListener("click", function (e) {
                    e.preventDefault();
                    if (window.theme && typeof theme.removeAddedCartDrawer === "function") {
                      theme.removeAddedCartDrawer();
                    }
                  });
                }
                $cartDrawerContainer.prependTo("body");
                setTimeout(function () {
                  cartDrawer.classList.remove("cart-summary-overlay--off-screen");
                }, 50);
              }
            } else if (!useDrawer) {
              window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart";
            }
          })
          .catch(function (err) {
            submitBtns.forEach(function (btn) {
              btn.disabled = false;
              btn.textContent = btn.dataset.previousValue || "Add to cart";
            });
            var message =
              (err && (err.description || err.message)) || "Could not add those options to the cart.";
            if (window.theme && typeof theme.showQuickPopup === "function") {
              theme.showQuickPopup(message, window.jQuery(submitBtns[0]));
            } else {
              window.alert(message);
            }
          });
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll(".option-selector--ph-accordion").forEach(bindAccordion);
    document.querySelectorAll(".product-form").forEach(bindMultiAdd);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
})();

(function () {
  function focusFooterNewsletter() {
    if (window.location.hash !== "#footer-newsletter") return;
    var email = document.getElementById("footer-newsletter-email");
    var box = document.getElementById("footer-newsletter");
    if (box) box.scrollIntoView({ behavior: "smooth", block: "center" });
    if (email) {
      window.setTimeout(function () {
        email.focus({ preventScroll: true });
      }, 350);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", focusFooterNewsletter);
  } else {
    focusFooterNewsletter();
  }
  window.addEventListener("hashchange", focusFooterNewsletter);
})();

(function () {
  /* Quick Buy / mobile card Quick buy — brief added feedback after cart updates */
  var LABEL_ADDED = "Added";
  var LABEL_DEFAULT = "Quick buy";

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cart_add_url) {
      return theme.routes.cart_add_url;
    }
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart/add.js";
  }

  function flashButton(btn) {
    if (!btn || btn.dataset.phQuickbuyBusy) return;
    btn.dataset.phQuickbuyBusy = "1";
    var original = btn.textContent;
    btn.classList.add("is-added");
    btn.textContent = LABEL_ADDED;
    window.setTimeout(function () {
      btn.classList.remove("is-added");
      btn.textContent = original || LABEL_DEFAULT;
      delete btn.dataset.phQuickbuyBusy;
    }, 1600);
  }

  function markLast(btn) {
    document.querySelectorAll("[data-ph-last-quickbuy]").forEach(function (el) {
      delete el.dataset.phLastQuickbuy;
    });
    if (btn) btn.dataset.phLastQuickbuy = "1";
  }

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest && event.target.closest(".ph-quickbuy, .quickbuy-toggle");
    if (toggle) markLast(toggle);

    var atc = event.target.closest && event.target.closest("[data-ph-card-atc]");
    if (!atc) return;

    event.preventDefault();
    event.stopPropagation();
    if (atc.disabled || atc.classList.contains("is-busy")) return;

    var variantId = Number(atc.getAttribute("data-variant-id") || "0");
    if (!variantId) return;

    markLast(atc);
    atc.classList.add("is-busy");
    atc.disabled = true;

    var useDrawer =
      window.theme && theme.settings && theme.settings.cart_type === "drawer";
    var payload = { items: [{ id: variantId, quantity: 1 }] };
    if (useDrawer) {
      payload.sections = "cart-drawer";
      payload.sections_url = window.location.pathname;
    }

    if (window.theme && typeof theme.removeAddedCartDrawer === "function") {
      theme.removeAddedCartDrawer();
    }

    fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (response) {
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:cartchanged", { bubbles: true, cancelable: false })
        );

        flashButton(atc);

        if (useDrawer && response.sections && response.sections["cart-drawer"] && window.jQuery) {
          var $cartDrawerContainer = window.jQuery(response.sections["cart-drawer"]);
          var cartDrawer = $cartDrawerContainer.find(".cart-summary-overlay")[0];
          if (cartDrawer) {
            cartDrawer.classList.add("cart-summary-overlay--off-screen");
            var shopMore = cartDrawer.querySelector(".shop-more");
            if (shopMore) {
              shopMore.addEventListener("click", function (e) {
                e.preventDefault();
                if (window.theme && typeof theme.removeAddedCartDrawer === "function") {
                  theme.removeAddedCartDrawer();
                }
              });
            }
            $cartDrawerContainer.prependTo("body");
            setTimeout(function () {
              cartDrawer.classList.remove("cart-summary-overlay--off-screen");
            }, 50);
          }
        } else if (!useDrawer) {
          window.location.href =
            (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") +
            "cart";
        }
      })
      .catch(function () {
        /* Fall back to product page if add fails */
        var block = atc.closest(".product-block");
        var link = block && block.querySelector("a.product-link");
        if (link && link.href) window.location.href = link.href;
      })
      .finally(function () {
        atc.classList.remove("is-busy");
        atc.disabled = false;
      });
  });

  document.addEventListener("theme:cartchanged", function () {
    var btn = document.querySelector("[data-ph-last-quickbuy]");
    if (btn && !btn.classList.contains("ph-card-atc")) flashButton(btn);
  });

  document.addEventListener("ajaxProduct:added", function () {
    var btn = document.querySelector("[data-ph-last-quickbuy]");
    if (btn && !btn.classList.contains("ph-card-atc")) flashButton(btn);
  });

  document.addEventListener("cart:updated", function () {
    var btn = document.querySelector("[data-ph-last-quickbuy]");
    if (btn && !btn.classList.contains("ph-card-atc")) flashButton(btn);
  });
})();

(function () {
  /* Collection filter dropdown — enhance native <details> when JS is available */
  document.addEventListener("click", function (event) {
    var openDetails = document.querySelectorAll(".ph-collection-filter-details[open]");
    if (!openDetails.length) return;
    openDetails.forEach(function (details) {
      if (details.contains(event.target)) return;
      details.removeAttribute("open");
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll(".ph-collection-filter-details[open]").forEach(function (details) {
      details.removeAttribute("open");
    });
  });
})();

(function () {
  /* Force muted autoplay on homepage + agency hero videos (no play button) */
  var SELECTOR = [
    "video.ph-autoplay-video",
    ".ph-figma.ph-hero video",
    ".ph-hero-media video",
    ".ph-agency-hero video",
    "video.ph-agency-hero-img"
  ].join(",");

  function prep(video) {
    if (!video || video.dataset.phAutoplayReady === "1") return;
    video.dataset.phAutoplayReady = "1";
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("autoplay", "");
    video.setAttribute("loop", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.removeAttribute("controls");
    video.controls = false;
  }

  function playAll() {
    document.querySelectorAll(SELECTOR).forEach(function (video) {
      prep(video);
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {
          /* Retry once on next user gesture / visibility */
        });
      }
    });
  }

  function boot() {
    playAll();
    document.addEventListener("touchstart", playAll, { once: true, passive: true });
    document.addEventListener("click", playAll, { once: true });
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) playAll();
    });
    window.addEventListener("pageshow", playAll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", playAll);
})();

(function () {
  /* Product image fallback — if lazysizes never runs (blocked theme JS), still show images */
  function pickWidth(el) {
    var w = Math.ceil((el.getBoundingClientRect().width || el.parentElement?.getBoundingClientRect().width || 360) * (window.devicePixelRatio || 1));
    var widths = [180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];
    for (var i = 0; i < widths.length; i++) {
      if (widths[i] >= w) return widths[i];
    }
    return widths[widths.length - 1];
  }

  function hydrate(img) {
    if (!img || img.dataset.phImgReady === "1") return;
    var dataSrc = img.getAttribute("data-src");
    var current = img.getAttribute("src") || "";
    if (dataSrc && dataSrc.indexOf("{width}") !== -1) {
      var url = dataSrc.replace("{width}", String(pickWidth(img)));
      if (!current || current.indexOf("{width}") !== -1) {
        img.setAttribute("src", url);
      }
    }
    img.classList.add("lazyloaded");
    img.classList.remove("lazyload");
    img.style.opacity = "1";
    img.dataset.phImgReady = "1";
  }

  function hydrateAll() {
    document.querySelectorAll(".product-block .rimage__image, .rimage__image.lazyload").forEach(hydrate);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hydrateAll);
  } else {
    hydrateAll();
  }
  window.addEventListener("load", hydrateAll);
  document.addEventListener("shopify:section:load", hydrateAll);
  window.setTimeout(hydrateAll, 800);
  window.setTimeout(hydrateAll, 2500);
})();

